var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetsInternalapp24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2129 9.75H3.21289V8.25H22.2129V9.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7127 6C6.7127 5.44772 7.16042 5 7.7127 5H7.72168C8.27397 5 8.72168 5.44772 8.72168 6C8.72168 6.55228 8.27397 7 7.72168 7H7.7127C7.16042 7 6.7127 6.55228 6.7127 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7127 6C10.7127 5.44772 11.1604 5 11.7127 5H11.7217C12.274 5 12.7217 5.44772 12.7217 6C12.7217 6.55228 12.274 7 11.7217 7H11.7127C11.1604 7 10.7127 6.55228 10.7127 6Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8227 13.2754C22.8227 12.8612 22.4869 12.5254 22.0727 12.5254H15.5032V14.0254H22.0727C22.4869 14.0254 22.8227 13.6896 22.8227 13.2754Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6502 11.0151C17.3598 10.7198 16.8849 10.7158 16.5896 11.0063L15.1924 12.3803C14.6973 12.8672 14.694 13.6644 15.185 14.1554L16.5853 15.5557C16.8782 15.8486 17.3531 15.8486 17.646 15.5557C17.9389 15.2628 17.9389 14.7879 17.646 14.4951L16.4239 13.273L17.6414 12.0758C17.9367 11.7853 17.9407 11.3105 17.6502 11.0151Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60315 3.33008H17.8227C19.7557 3.33008 21.3227 4.89708 21.3227 6.83008V10.5283C21.3227 10.8045 21.5466 11.0283 21.8227 11.0283H22.3227C22.5988 11.0283 22.8227 10.8045 22.8227 10.5283V6.83008C22.8227 4.06865 20.5841 1.83008 17.8227 1.83008H7.60315C4.84173 1.83008 2.60315 4.06865 2.60315 6.83008V17.1699C2.60315 19.9313 4.84173 22.1699 7.60315 22.1699H17.8227C20.5841 22.1699 22.8227 19.9313 22.8227 17.1699V16.0381C22.8227 15.7619 22.5988 15.5381 22.3227 15.5381H21.8227C21.5466 15.5381 21.3227 15.7619 21.3227 16.0381V17.1699C21.3227 19.1029 19.7557 20.6699 17.8227 20.6699H7.60315C5.67015 20.6699 4.10315 19.1029 4.10315 17.1699V6.83008C4.10315 4.89708 5.67015 3.33008 7.60315 3.33008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsInternalapp24);
export default __webpack_public_path__ + "static/media/assets-internalapp-24.a3bbbd1aa14c5562662506ebf8d02d12.svg";
export { ForwardRef as ReactComponent };